import { jobBoardAPI } from './base';
import { AxiosResponse } from 'axios';

const jobTypeEndpoint = {
  getAll: '/job-type',
  update: '/job-type/:{id}',
  create: '/job-type',
  search: '/job-type/search'
};

export interface JobType {
  _id?: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface JobTypeDto {
  name: string;
  description: string;
}

export const GET_JOBTYPE_QUERY = async (): Promise<AxiosResponse<JobType[]>> =>
  (await jobBoardAPI.get(jobTypeEndpoint.getAll)).data;

export const CREATE_JOB_TYPE = async (
  data: JobTypeDto
): Promise<AxiosResponse<JobType>> =>
  jobBoardAPI.post(jobTypeEndpoint.create, data);

export const DELETE_JOB_TYPE = async (
  jobTypeId: string
): Promise<AxiosResponse<void>> => {
  const endpoint = `/job-type/${jobTypeId}`;
  return jobBoardAPI.delete(endpoint);
};

export const UPDATE_JOB_TYPE = async ({
  jobTypeId,
  data
}: {
  jobTypeId: string;
  data: JobTypeDto;
}): Promise<AxiosResponse<JobType>> =>
  jobBoardAPI.patch(jobTypeEndpoint.update.replace(':{id}', jobTypeId), data);

export const SEARCH_JOB_TYPES = async (
  query: string
): Promise<AxiosResponse<JobType[]>> => {
  const response = await jobBoardAPI.get(
    `${jobTypeEndpoint.search}?q=${query}`
  );
  return response.data;
};
